import { Component, OnInit } from '@angular/core';

import { Stock } from '../../models/stock';
import { StockService } from '../../services/stock.service';

@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.css']
})

export class StockComponent implements OnInit {
  errorMessage: string;
  stockList: Stock[];
  isLoading = true;

  constructor(private stockService: StockService) {
  }

  ngOnInit() {
    this.getStock();
  }

  getStock(): void {
    this.stockService.getStock()
          .subscribe(x => {
            this.stockList = x.map(this.calculateFields);
            this.isLoading = false;
            }, err => {
              this.errorMessage = 'Could not load stock: ' + err.error + ' (' + err.status + ')';
              this.isLoading = false;
            });
  }

  calculateFields(stock: Stock): Stock {
    stock.remaining = stock.initialStock - stock.sold;
    if (stock.initialStock === 0) {
      return stock;
    }
    
    if (stock.remaining < stock.reservedNotSold) {
      stock.isError = true;
    } else if ((stock.remaining < stock.reservedNotSold + 5 && stock.initialStock > 99) || stock.remaining < stock.reservedNotSold + 2) {
      stock.isWarning = true;
    }

    return stock;
  }
}



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/app/pages/stock/stock.component.ts